export function AddSequenceTag(organizationID: number, ID: number, tagID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/${ID}/tags/${tagID}`;
}

export function AddVideoSequenceUser(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/${ID}/users`;
}

export function AggregatedIndex(organizationID: number): string {
	return `/v1/organizations/${organizationID}/videos/all`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/videos`;
}

export function CreateSequence(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/videos/${ID}/sequences`;
}

export function CreateVideoSequenceComment(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/${ID}/comments`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/videos/${ID}`;
}

export function DeleteSequence(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/${ID}`;
}

export function DeleteVideoSequenceComment(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/comments/${ID}`;
}

export function DeleteVideoSequenceUser(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequence-users/${ID}`;
}

export function GenerateGenericOEmbed(): string {
	return `/v1/video-oembed`;
}

export function GenerateVeoOEmbed(): string {
	return `/v1/video-oembed/veo`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/videos`;
}

export function ListVideosFromWingfield(organizationID: number): string {
	return `/v1/organizations/${organizationID}/video-sources/wingfield`;
}

export function RemoveSequenceTag(organizationID: number, ID: number, tagID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/${ID}/tags/${tagID}`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/videos/${ID}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/videos/${ID}`;
}

export function UpdateSequence(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/${ID}`;
}

export function UpdateVideoSequenceComment(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequences/comments/${ID}`;
}

export function UpdateVideoSequenceUser(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/video-sequence-users/${ID}`;
}

